import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/JobDetail.css";
import axios from "axios";
import { resolveMediaUrl } from "../utils/mediaUrl";
import {useCareerLanguage,careerRequest,asArray} from "../career/CareerLanguage";
import {jobLabel,jobLocation,jobDeadline} from '../utils/jobPresentation';
import {catalogLabel} from '../career/CareerCatalog';
import {BriefcaseBusiness,MapPin} from 'lucide-react';
import {useRef} from 'react';
import CareerApplicationDialog from '../career/CareerApplicationDialog';
import {applicationError,applicationConfirmed} from '../career/applicationErrors';
import Login from '../components/Login';

const JobDetail = () => {
  const {t,lang}=useCareerLanguage(),{id}=useParams(),navigate=useNavigate();
  const [job,setJob]=useState(null),[loading,setLoading]=useState(true);
  const [showPopup,setShowPopup]=useState(false),[showLogin,setShowLogin]=useState(false),[aciklama,setAciklama]=useState('');
  const [popupLoading,setPopupLoading]=useState(false),[zatenBasvuruldu,setZatenBasvuruldu]=useState(false),[basvuruBasarili,setBasvuruBasarili]=useState(false);
  const [gate,setGate]=useState('checking'),[uyari,setUyari]=useState(null),[submitError,setSubmitError]=useState(null),[revision,setRevision]=useState(0);
  const submitting=useRef(false),postController=useRef(null),routeVersion=useRef(0);
  const token=localStorage.getItem('token');
  useEffect(()=>{
    const version=++routeVersion.current,controller=new AbortController();
    setLoading(true);setJob(null);setShowPopup(false);setAciklama('');setSubmitError(null);setBasvuruBasarili(false);setZatenBasvuruldu(false);setPopupLoading(false);setUyari(null);setGate(token?'checking':'anonymous');
    (async()=>{
      try{
        const res=await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/ilan/getir/${id}`,{signal:controller.signal});
        if(controller.signal.aborted||version!==routeVersion.current)return;
        const found=res.data?.status===true?res.data:null;setJob(found);
        if(found&&token){
          const [applications,profile]=await Promise.all([
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/basvurularim`,{headers:{Authorization:'Bearer '+token},signal:controller.signal}),
            careerRequest('','GET',undefined,{signal:controller.signal})
          ]);
          if(controller.signal.aborted||version!==routeVersion.current)return;
          setZatenBasvuruldu(asArray(applications.data).some(row=>Number(row.ilanId)===Number(found.ilanId)&&row.status===true));
          setGate(profile.tamamlandi===true?'ready':'incomplete');
        }
      }catch(error){
        if(controller.signal.aborted||version!==routeVersion.current)return;
        const failure=applicationError(error);
        setGate('error');setUyari(error.response?.status===401||error.response?.status===403?failure:{key:'appCheckFailed',action:'check'});
      }finally{if(!controller.signal.aborted&&version===routeVersion.current)setLoading(false);}
    })();
    return()=>{controller.abort();postController.current?.abort();postController.current=null;submitting.current=false;};
  },[id,token,revision]);
  const handleAction=action=>{
    if(submitting.current)return;
    if(action==='login'){setShowPopup(false);setShowLogin(true);}
    else if(action==='profile'){setShowPopup(false);navigate('/ozgecmisim');}
    else if(action==='applications'){setShowPopup(false);navigate('/basvurularim');}
    else if(action==='check')setRevision(value=>value+1);
  };
  const handleBasvurClick=()=>{
    if(!token){setUyari({key:'appLoginRequired',action:'login'});setShowLogin(true);return;}
    if(gate==='incomplete'){setUyari({key:'appProfileIncomplete',action:'profile'});return;}
    if(gate!=='ready'||submitting.current||zatenBasvuruldu)return;
    setSubmitError(null);setUyari(null);setShowPopup(true);
  };
  const handleSubmit=async()=>{
    if(submitting.current||zatenBasvuruldu||!job)return;
    if(!token||localStorage.getItem('token')!==token){setSubmitError({key:'appLoginRequired',action:'login'});return;}
    if(gate!=='ready'){setSubmitError({key:'appProfileIncomplete',action:'profile'});return;}
    if(aciklama.length>255){setSubmitError({key:'appLetterTooLong'});return;}
    const version=routeVersion.current,controller=new AbortController();postController.current=controller;
    submitting.current=true;setPopupLoading(true);setSubmitError(null);
    try{
      const response=await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/ekle`,{basvuranAciklama:aciklama.trim(),ilanId:job.ilanId},{headers:{Authorization:'Bearer '+token},signal:controller.signal});
      if(controller.signal.aborted||version!==routeVersion.current)return;
      if(!applicationConfirmed(response.data)){setSubmitError({key:'appResultUnknown',action:'applications'});return;}
      setAciklama('');setZatenBasvuruldu(true);setBasvuruBasarili(true);
    }catch(error){
      if(controller.signal.aborted||version!==routeVersion.current)return;
      const failure=applicationError(error);setSubmitError(failure);if(failure.already)setZatenBasvuruldu(true);
    }finally{
      if(postController.current===controller){postController.current=null;submitting.current=false;setPopupLoading(false);}
    }
  };

  if (loading) return <p>{t('loading')}</p>;
  if (!job) return <p>{t('emptyJobs')}</p>;
  const location=jobLocation(job,lang),position=catalogLabel('position',jobLabel(job.ilanPozisyonAdi),lang),deadline=jobDeadline(job.gecerlilikTarihi,lang);

  const detailPhotoUrl = job.detaydaKapakFotografiniKullan
    ? job.ilanFotoUrl
    : (job.ilanDetayFotoUrl || job.ilanFotoUrl);
  const detailPhotoPosition = ["Ustte", "AciklamaOncesi", "AciklamaSonrasi"].includes(job.detayFotoKonumu)
    ? job.detayFotoKonumu
    : "Ustte";

  const detailPhotoBlock = (topPosition = false) => (
    <div className={`job-detail-cover ${topPosition ? "job-detail-cover--top" : "job-detail-cover--content"}`}>
      {detailPhotoUrl ? (
        <img
          src={resolveMediaUrl(detailPhotoUrl)}
          alt={job.ilanBaslik}
          onError={(event) => {
            event.currentTarget.style.display = "none";
            event.currentTarget.nextElementSibling?.classList.add("is-visible");
          }}
        />
      ) : null}
      <div className={`job-detail-cover-fallback ${detailPhotoUrl ? "" : "is-visible"}`}>
        <span>FULLA KARİYER</span>
      </div>
    </div>
  );

  return (
    <div className="job-detail-container">
      <div className="job-detail-box">
        {detailPhotoPosition === "Ustte" && detailPhotoBlock(true)}
        <div className="job-header">
          <h1 className="job-title-header">{job.ilanBaslik}</h1>
          {deadline && (
            <span className="job-deadline-tag">
              {t('deadline')}: {deadline}
            </span>
          )}
        </div>

        {(position||location)&&<div className="job-meta-info">
          {position&&<p><BriefcaseBusiness size={17} aria-hidden="true"/><strong>{t('position')}:</strong><span>{position}</span></p>}
          {location&&<p className="lokasyon"><MapPin size={17} aria-hidden="true"/><span>{location}</span></p>}
        </div>}

        {detailPhotoPosition === "AciklamaOncesi" && detailPhotoBlock()}

        <div
          className="job-detail-description"
          dangerouslySetInnerHTML={{ __html: job.ilanAciklamasi }}
        ></div>

        {detailPhotoPosition === "AciklamaSonrasi" && detailPhotoBlock()}

        {uyari&&!showPopup&&<div className="uyari-bildirimi" role="alert"><span>{t(uyari.key)}</span>{uyari.action&&<button className="uyari-btn" type="button" onClick={()=>handleAction(uyari.action)}>{t(uyari.action==='login'?'login':uyari.action==='check'?'retry':'finish')}</button>}</div>}


        {zatenBasvuruldu ? (
          <button className="apply-button" disabled>
            {t('applied')}
          </button>
        ) : (
          <button className="apply-button" type="button" onClick={handleBasvurClick} disabled={popupLoading||gate==='checking'}>
            {t('apply')}
          </button>
        )}

      </div>


      {showPopup&&<CareerApplicationDialog jobTitle={job.ilanBaslik} value={aciklama} onChange={value=>{setAciklama(value);if(submitError?.key==='appLetterTooLong')setSubmitError(null);}} busy={popupLoading} success={basvuruBasarili} error={submitError} alreadyApplied={zatenBasvuruldu} onSubmit={handleSubmit} onClose={()=>{if(!submitting.current)setShowPopup(false);}} onAction={handleAction} onApplications={()=>handleAction('applications')}/>}
      {showLogin&&<Login onClose={()=>setShowLogin(false)}/>}
    </div>
  );
};

export default JobDetail;
